export type LightSimulation = { mode: 'off' | 'fixed' | 'adjustable'; maxTilt: number };
export function lightSimulation(sku: string, specs: Record<string, unknown>): LightSimulation {
 const raw = specs._light_simulation;
 if (raw == null) return sku === 'NDD12_127XXXX_X' ? {mode:'adjustable',maxTilt:35} : {mode:'off',maxTilt:0};
 try {
  const c = typeof raw === 'string' ? JSON.parse(raw) : raw;
  if (c.mode === 'fixed') return {mode:'fixed',maxTilt:0};
  if (c.mode === 'adjustable' && Number.isFinite(c.maxTilt) && c.maxTilt >= 0 && c.maxTilt <= 90) return c;
 } catch { /* Unknown configuration stays disabled. */ }
 return {mode:'off',maxTilt:0};
}
